module.exports = __webpack_public_path__ + "img/4m1.745d6774.jpg";